module.exports = __webpack_public_path__ + "0af92e5fd765eb47d2c3123200e60c4b.fbx";